import { createFileRoute } from '@tanstack/react-router'

/**
 * FAQ page route.
 * Displays frequently asked questions.
 */
export const Route = createFileRoute('/faq')({
  component: FaqPage,
})

function FaqPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="mx-auto max-w-3xl space-y-8">
        <h1 className="text-4xl font-bold text-center">
          Domande Frequenti
        </h1>
        <p className="text-center text-muted-foreground">
          Trova le risposte alle domande più comuni su GeierTime.
        </p>

        <div className="space-y-4">
          <div className="rounded-lg border border-border bg-card p-6">
            <h3 className="font-semibold mb-2">Cos'è GeierTime?</h3>
            <p className="text-muted-foreground">
              GeierTime è una piattaforma completa per la gestione del tempo,
              il tracking delle attività e l'analisi della produttività del tuo team.
            </p>
          </div>

          <div className="rounded-lg border border-border bg-card p-6">
            <h3 className="font-semibold mb-2">Come posso iniziare?</h3>
            <p className="text-muted-foreground">
              Scegli il piano che fa per te e completa il checkout.
              Riceverai immediatamente l'accesso alla piattaforma.
            </p>
          </div>

          <div className="rounded-lg border border-border bg-card p-6">
            <h3 className="font-semibold mb-2">È disponibile un piano gratuito?</h3>
            <p className="text-muted-foreground">
              Sì, offriamo un piano gratuito con funzionalità di base.
              Puoi aggiornare in qualsiasi momento.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
